export const recordingsData = [
    {
        id: 1,
        name: "Jane Doe",
        avatar: "/src/assets/images/thumbnail.png",
        message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        time: "0.00",
    },
    {
       id: 2,
        name: "Jane Doe",
        avatar: "/src/assets/images/thumbnail.png",
        message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        time: "0.10", 
    },
    {
       id: 3,
        name: "Jane Doe",
        avatar: "/src/assets/images/thumbnail.png",
        message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        time: "0.20", 
    },
    {
       id: 4,
        name: "Jane Doe",
        avatar: "/src/assets/images/thumbnail.png",
        message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        time: "0.30",

    },
]